const stringifySpaceCount = 4;

export abstract class FormatUtil {
  static stringify(object: Object) {
    return JSON.stringify(object, null, stringifySpaceCount);
  }
}
